import { jsx as _jsx } from "react/jsx-runtime";
import Add from "components/Emails/Add";
import ADD_EMAILS_HEADINGS from "mutations/emails/addEmailsHeading";
import GET_EMAILS_HEADINGS from "queries/emails/getEmailsHeadings";
import React from "react";
const HeadingsAdd = () => (_jsx(Add, { addMutation: ADD_EMAILS_HEADINGS, itemName: "heading", listQuery: GET_EMAILS_HEADINGS }));
export default HeadingsAdd;
